import React from "react";

import { withAppState } from "../../../shared/containers/containerAppState";

import CarsCounterWrapper from "./carsCounterWrapper";
import FirstTitle from "../../../shared/items/static/firstTitle";
import TitleClosedBarWrapper from "./../../../shared/titleClosedBarWrapper";

import styles from "./carsTitleClosedBar.module.scss";

const CARS_BAR_TITLE = "Автомобили";

const CarsTitleClosedBar = (props) => {
  return !props.isSideBarOpen ? (
    <TitleClosedBarWrapper>
      <FirstTitle>
        {CARS_BAR_TITLE}
        <div className={styles.container_titleCounter}>
          <CarsCounterWrapper />
        </div>
      </FirstTitle>
    </TitleClosedBarWrapper>
  ) : null;
};

export default withAppState(React.memo(CarsTitleClosedBar));
